import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Panel from "../components/common/Panel";
import Seo from "../components/common/Seo";
import { t } from "../i18n/messages";
import { useAppState } from "../state/AppStateProvider";
import { buildPath } from "../utils/routing";

export default function DetailPage({ locale }) {
  const [params] = useSearchParams();
  const { assets, assetsLoading } = useAppState();
  const id = params.get("id") || assets[0]?.id;
  const nft = useMemo(() => assets.find((item) => item.id === id) || assets[0], [assets, id]);

  if (assetsLoading) {
    return (
      <Panel title={t(locale, "navDetail")} description={t(locale, "detailDesc")}>
        <p>{t(locale, "detailLoading")}</p>
      </Panel>
    );
  }

  if (!nft) {
    return (
      <Panel title={t(locale, "navDetail")} description={t(locale, "detailDesc")}>
        <p>{t(locale, "detailNoAssets")}</p>
      </Panel>
    );
  }

  return (
    <>
      <Seo
        locale={locale}
        title={`${nft.name} | Chronos Arte Node`}
        description={nft.description || "RWA 资产详情"}
        path={`${buildPath(locale, "detail")}?id=${encodeURIComponent(nft.id)}`}
      />

      <Panel title={t(locale, "navDetail")} description={t(locale, "detailDesc")}>
        <div className="detail-grid">
          <div className="box">
            {nft.image ? (
              <img className="detail-image" src={nft.image} alt={nft.name} />
            ) : (
              <div className="detail-image" style={{ display: "grid", placeItems: "center", minHeight: 280 }}>
                {t(locale, "detailNoImage")}
              </div>
            )}
          </div>
          <div className="box">
            <h3>{nft.name}</h3>
            <p>{nft.description || t(locale, "detailNoDescription")}</p>
            <ul className="kv-list">
              <li><span>{t(locale, "detailArtist")}</span><strong>{nft.artist || "-"}</strong></li>
              <li><span>{t(locale, "detailType")}</span><strong>{nft.type || "-"}</strong></li>
              <li><span>{t(locale, "detailChain")}</span><strong>{nft.chainName || nft.chainId || "-"}</strong></li>
              <li><span>{t(locale, "detailNftContract")}</span><strong>{nft.nftAddress || "-"}</strong></li>
              <li><span>{t(locale, "detailTokenId")}</span><strong>{nft.tokenId || "-"}</strong></li>
              <li><span>{t(locale, "detailCurrentPrice")}</span><strong>{nft.currentPrice != null ? `${nft.currentPrice} ${nft.quoteSymbol || "ETH"}` : "-"}</strong></li>
              <li><span>{t(locale, "detailLastSale")}</span><strong>{nft.lastSale != null ? `${nft.lastSale} ${nft.quoteSymbol || "ETH"}` : "-"}</strong></li>
              <li><span>{t(locale, "detailOwner")}</span><strong>{nft.owner || "-"}</strong></li>
            </ul>
          </div>
        </div>
      </Panel>

      <Panel title={t(locale, "detailProofTitle")} description={t(locale, "detailProofDesc")}>
        <div className="card-grid three-cols">
          <article className="card-link">
            <h3>{t(locale, "detailCustodyHash")}</h3>
            <p>{nft.proof?.custodyHash || "-"}</p>
          </article>
          <article className="card-link">
            <h3>{t(locale, "detailAppraisalHash")}</h3>
            <p>{nft.proof?.appraisalHash || "-"}</p>
          </article>
          <article className="card-link">
            <h3>{t(locale, "detailValuationHash")}</h3>
            <p>{nft.proof?.valuationHash || "-"}</p>
          </article>
        </div>
      </Panel>
    </>
  );
}
